/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reset_Request_SentInputs */



/**
* | output |
* | --- |
* | "If an account exists for that address, a reset link is on its way." |
*
* @param {Reset_Request_SentInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reset_request_sent = /** @type {((inputs?: Reset_Request_SentInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reset_Request_SentInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("If an account exists for that address, a reset link is on its way.")
});